import { IconMail, IconPhone } from '@tabler/icons-react'
import clsx from 'clsx'
import Image from 'next/image'
import Link from 'next/link'
import PaymentMethods from 'public/static/payment-methods.webp'

import LazyLoader from 'shared/ui/LazyLoader/LazyLoader'
import { PATHS } from 'shared/utils/paths'
import { addTestId } from 'shared/utils/tests'

import styles from './Footer.module.scss'

const Footer = ({
  isPaymentProccesPage
}: {
  isPaymentProccesPage?: boolean
}) => {
  return (
    <footer
      className={clsx(styles.wrapper, {
        [styles.paymentProcessPage]: isPaymentProccesPage
      })}
    >
      <LazyLoader>
        <div className={styles.contentWrapper}>
          <div className={styles.content}>
            <div className={styles.contentTop}>
              <div className={styles.section}>
                <Image
                  src='/static/lokalny-rolnik.svg'
                  alt='Logo Lokalny Rolnik'
                  width={139}
                  height={43}
                />
              </div>
              <div className={styles.section}>
                <h2
                  className={styles.sectionTitle}
                  {...addTestId('footer-section-title')}
                >
                  Dostawa
                </h2>
                <Link className={styles.link} href={PATHS.deliveryArea}>
                  Obszary dostawy
                </Link>
                <Link className={styles.link} href={PATHS.deliveryTime}>
                  Terminy i metody dostawy
                </Link>
                <Link className={styles.link} href={PATHS.deliveryCost}>
                  Koszty dostawy
                </Link>
                <Link className={styles.link} href={PATHS.paymentMethods}>
                  Metody płatności
                </Link>
              </div>
              <div className={styles.section}>
                <h2
                  className={styles.sectionTitle}
                  {...addTestId('footer-section-title')}
                >
                  Informacje
                </h2>
                <Link className={styles.link} href={PATHS.quality}>
                  Gwarancja jakości
                </Link>
                <Link className={styles.link} href={PATHS.faq} rel='nofollow'>
                  Pytania i odpowiedzi
                </Link>
                <Link
                  className={styles.link}
                  href={PATHS.howToRegister}
                  rel='nofollow'
                >
                  Jak założyć konto
                </Link>
                <Link
                  className={styles.link}
                  href={PATHS.termsAndConditions}
                  rel='nofollow'
                >
                  Regulamin
                </Link>
                <Link
                  className={styles.link}
                  href={PATHS.privacy}
                  rel='nofollow'
                >
                  Polityka prywatności
                </Link>
                <Link
                  className={styles.link}
                  href={PATHS.cancellation}
                  rel='nofollow'
                >
                  Odstąpienie od umowy
                </Link>
              </div>
              <div className={styles.section}>
                <h2
                  className={styles.sectionTitle}
                  {...addTestId('footer-section-title')}
                >
                  Lokalny Rolnik
                </h2>
                <Link className={styles.link} href={PATHS.aboutUs}>
                  O nas
                </Link>
                <a className={styles.link} href='https://blog.lokalnyrolnik.pl'>
                  Blog
                </a>
                <Link className={styles.link} href={PATHS.cooperation}>
                  Współpraca
                </Link>
                {/* <StyledLink href={PATHS.brand}>Wytwórcy</StyledLink> */}
              </div>
              <div className={styles.section}>
                <h2
                  className={styles.sectionTitle}
                  {...addTestId('footer-section-title')}
                >
                  Jesteśmy do Twojej dyspozycji!
                </h2>
                <Link className={styles.link} href='tel:+48570519595'>
                  <IconPhone strokeWidth={1} /> +48 570 519 595
                </Link>
                <Link
                  className={styles.link}
                  href='mailto:bok@lokalnyrolnik.pl'
                >
                  <IconMail strokeWidth={1} />
                  bok@lokalnyrolnik.pl
                </Link>
                <p className={styles.text}>
                  Od poniedziałku do piątku
                  <br />
                  w&nbsp;godzinach 9:00&nbsp;-&nbsp;17:00
                </p>
                <div className={styles.socialIcons}>
                  <Link
                    className={styles.link}
                    href='https://www.facebook.com/lokalnyrolnikpl'
                    target='_blank'
                    rel='nofollow'
                  >
                    <Image
                      src='/static/fb.svg'
                      width={24}
                      height={24}
                      alt='Facebook'
                    />
                  </Link>
                  <Link
                    className={styles.link}
                    href='https://www.instagram.com/lokalnyrolnikpl/'
                    target='_blank'
                    rel='nofollow'
                  >
                    <Image
                      src='/static/ig.svg'
                      width={24}
                      height={24}
                      alt='Instagram'
                    />
                  </Link>
                </div>
              </div>
            </div>
            <div className={styles.contentBottom}>
              <div className={styles.section}>
                Wszelkie prawa zastrzeżone ©&nbsp;{new Date().getFullYear()}
                &nbsp;Lokalny Rolnik
              </div>
              <div className={styles.section}>
                <Image
                  src={PaymentMethods}
                  alt='Dostępne metody płatności: Blik, Apple Pay, Google Pay, karty płatnicze Visa, Mastercard'
                  width={200}
                  height={40}
                />
              </div>
            </div>
          </div>
        </div>
      </LazyLoader>
    </footer>
  )
}

export default Footer
